import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidationErrors, FormBuilder, FormArray} from '@angular/forms';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { logisticaModulo as diccionarios} from '../../logistica-diccionario';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { CentroAlmacen } from '../../../traslado-logist/model/asignacion-centro.model';
import { ITiposViajesShort, ITrackingViajes } from '../../model/modelTracking';
import { LogisticaService } from '../../service/logistica.services';
import { CatalogosLogisticaService } from '../../service/catalogosLogistica.service';
import { Placa } from 'src/app/model/datos-maestros/placa';
import { Chofer } from '../../../traslado-logist/model/model';
import { OrdenBalanzaService } from 'src/app/aplicaciones-modulos/balanza/services/orden-balanza.service';
import { IOrdenBalanza } from 'src/app/aplicaciones-modulos/balanza/modelos/IOrdenBalanza';
import { TicketAutorizacionTransporteService } from 'src/app/aplicaciones-modulos/balanza/services/ticket-autorizacion-transporte.service';
import { IAreaLogistica, ITiposPlanificacion } from '../../model/modelConfiguracional';
import { ColDef, ColGroupDef, GridApi, GridOptions, CsvExportModule} from 'ag-grid-community';
import { ClaveValorModel } from 'src/app/model/datos-maestros/claveValorModel';
import { forkJoin } from 'rxjs';
import { TrackingConfiguracionService } from '../../service/trackingConfiguracion.services';
import { MantenimientoOrigenesExtractorasService } from 'src/app/aplicaciones-modulos/balanza/services/mantenimiento-origenes-extractoras.service';
import { UsuarioBasculaGaritaService } from 'src/app/aplicaciones-modulos/balanza/services/usuario-bascula-garita.service';
import { TipoOrdenesBalanzaService } from 'src/app/aplicaciones-modulos/balanza/services/tipo-ordenes-balanza.service';


@Component({
  selector: 'app-reporte-bitacora',
  templateUrl: './reporte-bitacora.component.html',
  styleUrls: ['./reporte-bitacora.component.css']
})

export class ReporteBitacoraComponent implements OnInit {

  public DAT_TITULOS    = diccionarios.titulos.bitacora;
  public GLOBAL_TITULOS = diccionarios.titulos.global;
  public DAT_AG_GRID    = diccionarios.agGrid;

  public titleModal   : string;
  public loading      : boolean = false;
  public isCreate     : boolean = true;

  // variables para el grid
  public frameworkComponents: any;
  public columnDefs     : ColDef[] = [];
  public defaultColDef  : ColDef;
  public gridApi        : GridApi;
  public rowData        : any[] = [];
  public rowSelection   : any;
  public gridColumnApi  : any;
  public textoBuscar    : string;
  public usarioActual   : any;

  // variables funcionales
  public listCentros    : CentroAlmacen [] = [];
  public listTipos      : ITiposViajesShort  [] = [];
  public listTipos1     : ITiposPlanificacion [] = [];
  public listAreas      : IAreaLogistica[] = [];
  public listAgencias   : any[] = [];
  public listFurgones   : Placa [] = [];
  public cmbxEstados    : ClaveValorModel[] = [];
  public routear        : "planificador";
  public isBalanza      : boolean = false;
  public selected       : ITrackingViajes;
  public tipoSelected   : ITiposPlanificacion;
  public fechaHoraInicio: any;
  public requireCliente : boolean = false;

  //Formularios comentar 0
  public formulario: FormGroup;
  public isFocus: boolean = true;

  public formBalanza = new FormGroup({
    idViaje       : new FormControl(''),
    balanzaTicket : new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
    pesoIn        : new FormControl('', Validators.required),
    pesoOut       : new FormControl(''),
    garitaTicket  : new FormControl(''),
    fSalidaGarita : new FormControl(''),
    balanzaFechaInicio: new FormControl(''),
    balanzaFechaFin: new FormControl(''),
    estado        : new FormControl('', Validators.required),
    estadoOB      : new FormControl('', Validators.required),
    modificadoPor : new FormControl(''),
    });

  constructor(
    private fbServices      : FormBuilder,
    private utilServices    : UtilsService,
    private dmaestrosAPI    : DatosMaestrosService,
    private logisticaAPI    : LogisticaService,
    private _catalogos      : CatalogosLogisticaService,
    private rutaActiva      : ActivatedRoute,

    private balanzaAPI      : OrdenBalanzaService,
    private ticketGaritaApi : TicketAutorizacionTransporteService,
    private trackingConfiguracional: TrackingConfiguracionService,
    private balanzaAPIExtractoras: MantenimientoOrigenesExtractorasService,
    private usuarioBasculaAPI    : UsuarioBasculaGaritaService,
    private tipoOrdenesBalanzaS: TipoOrdenesBalanzaService,
  ) { }

  ngOnInit(): void {
    this.usarioActual = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
/*
    //Detectar cambio en tipos
    this.formulario.get('tipo').valueChanges.subscribe(valor => {
      if(valor != null){
        console.log("tipo seleccionado", valor);
        this.tipoSelected   = this.listTipos1.find(e=> e.idTipo == valor);
        this.requireCliente = this.tipoSelected.reqCliente;
        const PRIORIDAD     = this.listCatalogos.prioridades.find(e=> e.valor == this.tipoSelected.prioridadKanban);
        this.formulario.get('prioridad')?.setValue(PRIORIDAD.clave);
        this.manejarControlCompras(this.tipoSelected.tipoEscenario);
      }
    });

    //Suscribe a cambios para setear valores
    this.formulario.get('choferCedula').valueChanges.subscribe(valor => {
      if(valor != null && this.isCreate){
        this.formulario.get('choferTelefono').reset();
        this.formulario.get('choferTelefono').setValue(
        this.listChoferes.filter(e=>e.cedula == valor)[0].fono);
      }
    });

    //Suscribe a cambios de centro de destino
    this.formulario.get('centroDestino').valueChanges.subscribe(valor => {
      if(valor != null) this.getAreas();
    });*/

    this.cargarGridcomponent();
    this.inicializar();
  }


  cargarGridcomponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent, };
    this.columnDefs = [
      { filter: true, resizable: true, sortable: true, sort: 'desc', field: 'idBitacora' },
      { filter: true, resizable: true, field: 'viajeId' },
      { filter: true, resizable: true, field: 'proceso' },
      { filter: true, resizable: true, field: 'accion' },
      { filter: true, resizable: true, field: 'fecha' },
      { filter: true, resizable: true, field: 'fechaFin' },
      { filter: true, resizable: true, field: 'tabla' },
    ];

    this.rowSelection = 'multiple';
    this.defaultColDef = this._catalogos.getDefaultColDef();
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  
  onBtnExport() {
    this.gridApi.exportDataAsCsv();
  }

  listCatalogos;
  listOrigen;
  inicializar(){
    this.listTipos    = [];
    this.listCentros  = [];
    this.cmbxEstados  = this._catalogos.catalogoEstados();

    const _getAllCentros = this.dmaestrosAPI.getAllCentroLogistico();
    const _getAllTipos   = this.trackingConfiguracional.getAllTipos();
    const _getAllCatalogos= this.trackingConfiguracional.getAllCatalogos();
    const _getAllOrigenes = this.balanzaAPIExtractoras.obtener();

    forkJoin([_getAllCentros, _getAllTipos, _getAllCatalogos, _getAllOrigenes]).subscribe((res: any) => {
      this.listCentros = res[0];
      this.listCentros.map(centros => { centros.nombre = centros.id + ' - ' + centros.nombre; });
      this.listTipos1 = res[1];
      this.listCatalogos = res[2];
      this.listOrigen = res[3];
      if(res[3])this.listOrigen.map(e => { e.descripcion = e.proveedor + ' - ' + e.descripcion; });
      this.loading = false;
    }, () => {
      this.loading = false;
    });

    this.dmaestrosAPI.getAllCentroLogistico().subscribe((res) => {
      if(res)this.listCentros = res.map((e)=> {e.nombreCentro = e.idCentro +" - "+e.nombreCentro; return e});
    }, (err) => {
      console.log(err.message);
    });

    this.logisticaAPI.getTipos().subscribe((res) => {
      if(res) this.listTipos = res;
    }, (err) => {
      console.log(err.message);
    });

    this.listar();    
  }

  listar(){
    this.rowData = null;
    this.isCreate = true;
    this.logisticaAPI.getBitacora().subscribe((res) => {
      if(res) this.rowData = res;
    }, (err) => {
      console.log(err.message);
    });
  }
    
  //Función de copiado de grid
  copy(){
    const texto = this.utilServices.jsonToCsv(this.gridApi.getSelectedRows());
    navigator.clipboard.writeText(texto)
      .then(() => console.log('Copiado al portapapeles'))
      .catch(err => console.error('Error al copiar:', err));
  }

}
